<div class="d-flex align-items-center justify-content-between flex-wrap">
    <div class="fw-semibold">
        {{ title() }}
    </div>
    <div class="small text-muted">
        Entries: {{ entries().length }} · Expenses: {{ expenses().length }} · Conf. submitted:
        <span
            class="badge"
            [class.text-bg-success]="notification()?.isConfirmationSubmitted"
            [class.text-bg-secondary]="!notification()?.isConfirmationSubmitted"
        >
            {{ notification()?.isConfirmationSubmitted ? 'Yes' : 'No' }}
        </span>
    </div>
</div>

<accordion class="mt-2">
    <accordion-group heading="Entries ({{ entries().length }})" [isOpen]="entries().length > 0">
        @if (entries().length === 0) {
            <div class="text-muted small">No entries.</div>
        } @else {
            <div class="stack gap-2">
                @for (e of entries(); track $index) {
                    <pace-core-timesheet-entry-spector [entry]="e"></pace-core-timesheet-entry-spector>
                    <hr class="my-2" />
                }
            </div>
        }
    </accordion-group>

    <accordion-group heading="Expenses ({{ expenses().length }})" [isOpen]="expenses().length > 0">
        @if (expenses().length === 0) {
            <div class="text-muted small">No expenses.</div>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm table-striped align-middle">
                    <thead class="table-light">
                        <tr>
                            <th>Expense code(s)</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (x of expenses(); track $index) {
                            <tr>
                                <td class="small">{{ x.expenseCode?.join(', ') || '—' }}</td>
                                <td class="small">{{ x.expenseValue || '—' }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </accordion-group>

    <accordion-group heading="Distance">
        <div class="small">{{ distanceText() }}</div>
    </accordion-group>

    <accordion-group heading="Raw notification JSON">
        <pre class="small mb-0">{{ notification() | json }}</pre>
    </accordion-group>
</accordion>
